import Error from '@/features/common/components/Error'
import { logger } from '@/logger'
import { ErrorBoundaryProps } from 'expo-router'
import { reloadAsync } from 'expo-updates'
import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const RootLayoutErrorBoundary: FC<ErrorBoundaryProps> = ({ error }) => {
    const { t } = useTranslation()

    useEffect(() => {
        if (!__DEV__) logger.errorOnly(error)
    }, [error])

    if (__DEV__) throw error

    return (
        <Error
            title={t('errors.somethingBroken')}
            message={t('errors.tryRestartApp')}
            retry={reloadAsync}
            retryAction={t('actions.restart')}
        />
    )
}

export default RootLayoutErrorBoundary
